<button (click)="updateRoute()" class="tech-update-buttom"> 
    <span class="tech-update-buttom__text">{{ 'Actualizar Ruta'| translate }}</span>
</button>